import React from "react";

function PaymentCancel() {
    return (
        <div style={{ textAlign: "center", marginTop: "50px" }}>
            <h2>Thanh toán đã bị hủy</h2>
            <p>Bạn đã hủy giao dịch trên PayPal. Nếu muốn, hãy thử lại.</p>
        </div>
    );
}

export default PaymentCancel;
